export default "/assets/images/list-icon5.svg?4b0d701dddc37efc2db88a156463b3d4";